import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../constant/api';
import axios from 'axios';

function OfferImageBanner({ offerId, banner }) {
    const [banners, setBanners] = useState([]);

    // Fetch data from API with proper error handling
    const fetchData = async (url, setter) => {
        try {
            const response = await axios.get(url);
            const data = response.data.Data || response.data.data;
            if (data) {
                setter(data);
            }
        } catch (error) {
            console.error(`Error fetching data from ${url}:`, error);
            const errorMessage = error.response?.data?.message || "Failed to fetch data";
            console.log("Fetch data error message:", errorMessage);
        }
    };

    useEffect(() => {
        if (offerId) {
            fetchData(`${BASE_URL}/products/banners/`, setBanners);
        } else if (banner) {
            setBanners([banner]);  // Ensuring 'banner' is wrapped in an array for consistency
        }
    }, [offerId, banner]); // Dependency array includes offerId and banner

    if (banner) {
        return (
            <div className="p-5 w-screen h-auto object-fill rounded-sm">
                <img
                    src={`${BASE_URL}${banner}`} // Assuming banner is the image URL
                    alt="Offer Banner"
                    className="w-full h-full object-fill rounded-xl"
                />
            </div>
        );
    }

    return (
        <div className="p-5 w-full">
            {banners.length > 0 ? (
                banners
                    .filter((item) => item.id === parseInt(offerId)) // Filter banners based on offerId
                    .map((item, index) => (
                        <img
                            key={index}
                            src={`${BASE_URL}${item.banner}`} // Assuming 'banner' is the image URL
                            alt={item.title || "Offer Banner"}
                            className="w-screen sm:h-[150px] md:h-[258px] object-fill rounded-sm"
                        />
                    ))
            ) : (
                <p>No banners available</p> // Fallback message if no banners are available
            )}
        </div>
    );
}

export default OfferImageBanner;
